import { render, staticRenderFns } from "./ClientOpportunities.vue?vue&type=template&id=cc922426&scoped=true"
import script from "./ClientOpportunities.vue?vue&type=script&lang=js"
export * from "./ClientOpportunities.vue?vue&type=script&lang=js"
import style0 from "./ClientOpportunities.vue?vue&type=style&index=0&id=cc922426&prod&scoped=true&lang=css"
import style1 from "./ClientOpportunities.vue?vue&type=style&index=1&id=cc922426&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc922426",
  null
  
)

export default component.exports